const ITEMS = [
  "Weddings", "Corporate Events", "Birthday Parties", "Bulk Tiffins",
  "Live Counters", "Reception Dinners", "Pooja Bhandara", "Office Lunches",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="py-8 bg-primary text-primary-foreground overflow-hidden select-none">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif italic text-4xl sm:text-5xl px-6">{t}</span>
            <span className="text-accent text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
